import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useMemo } from "react";

const classNames = {
  input: `AddUserInput`,
  button: `AddUserButton`
};

export function useAddUserStyles() {
  return useMemo(
    () => mergeStyleSets({
      input: [
        classNames.input,
        {
          width: `100%`,
          "& .ms-TextField-fieldGroup": {
            borderTopRightRadius: `0%`,
            borderBottomRightRadius: `0%`
          }
        }
      ],
      button: [
        classNames.button,
        {
          width: `32px`,
          minWidth: `auto`,
          borderTopLeftRadius: `0%`,
          borderBottomLeftRadius: `0%`
        }
      ]
    }),
    []
  );
}
